import { createSelector } from '@ngrx/store';
import { ZonesState } from '../reducers/zones.reducer';
import { selectZonesState, selectTenantState } from '../reducers';
import { TenantState } from '../reducers/tenant.reducers';

export const getZonesTableState = createSelector(
  selectZonesState,
  (state: ZonesState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getZones = createSelector(
  selectZonesState,
  (state: ZonesState) => state.list
);

export const getTotalZones = createSelector(
  getZonesTableState,
  (tableState) => tableState.total
);

export const getZonesCurrentPage = createSelector(
  getZonesTableState,
  (tableState) => tableState.currentPage
);

export const getZonesPerPage = createSelector(
  getZonesTableState,
  (tableState) => tableState.perPage
);

export const getZonesDirection = createSelector(
  getZonesTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getZonesTableState,
  (tableState) => tableState.filters
);

export const getZoneDialogId = createSelector(
  selectZonesState,
  (state: ZonesState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
  selectZonesState,
  (state: ZonesState) => state.selectionDialogId
);

// Selettore per ottenere selectedTenantId da ZonesState
export const selectSelectedTenantId = createSelector(
  selectZonesState,
  (state: ZonesState) => {
    //console.log('selectedTenantId:', state.selectedTenantId);
    return state.selectedTenantId
  }
);

export const selectTenantName = createSelector(
  selectTenantState,  // Stato dei tenant
  selectSelectedTenantId,  // selectedTenantId da ZonesState
  (tenantState: TenantState, selectedTenantId: number) => {
    //console.log('TenantState:', tenantState);
    const tenant = tenantState.list.find(t => t.id === selectedTenantId);
    return tenant ? tenant.name : null;
  }
);



// Sviluppo futuro per selezionare tenant dinamicamente

// export const getSelectedTenant = createSelector(
//     selectZonesState,
//   (state: TenantState) => {
//     console.log("🔹 Stato completo nel selettore:", state);
//     console.log("🔹 selectedTenants nel selettore:", state.selectedTenants);
//     return state.selectedTenants.length > 0 ? state.selectedTenants[0] : null
//   }
// );




// export const getSelectedTenants = createSelector(
//    selectZonesState,
//   (state: ZonesState) => state.list

// );

export const getSelectedZonesCurrentPage = createSelector(
selectZonesState,
  (state: ZonesState) => {
    const selectedHours = (state.selectedZones || []).map(bl => bl.id);
    return state.list?.filter(bl => selectedHours.includes(bl.id));
  }
);
